import { AppRoute } from '@ts-routes/enums'
import { TasksKanbanTeam } from '@ts-tasks-kanban/enums'

import { useKanbanTasksApi } from '@api/tasks-kanban/kanban-tasks.hook'
import { parseFilterParams } from '@hooks/tasks-kanban/filters/parse-filter-params'

import { defineNuxtRouteMiddleware } from '#app'

const teamByRoute: Record<string, TasksKanbanTeam> = {
  [AppRoute.TasksKanbanSupport]: TasksKanbanTeam.Support,
  [AppRoute.TasksKanbanSuccess]: TasksKanbanTeam.Success,
  [AppRoute.TasksKanbanBilling]: TasksKanbanTeam.Billing,
}

export default defineNuxtRouteMiddleware((to) => {
  const team = teamByRoute[to.path]

  if (!team) return

  const params = parseFilterParams(to.query)

  void useKanbanTasksApi({ team, params })
})
